<template>
  <div>
    <div class="bannerBox">
      <a-carousel :dot-position="bottom">
        <div>
          <!-- <img class="bannerImg" src="../img/announcement.jpg" /> -->
        </div>
      </a-carousel>
    </div>
    <div style="width: 100%;background-color: #fff;">
      <div class="breadBox">
        <a-breadcrumb>
          <span>
            <img src="@/assets/img/position.png" />
            当前位置：
          </span>
          <a-breadcrumb-item @click="$router.push({ path: '/knowledge/index'})">首页</a-breadcrumb-item>
          <a-breadcrumb-item>{{ title }}</a-breadcrumb-item>
        </a-breadcrumb>
      </div>
      <div class="tabBox">
        <div class="activityContent">
          
        <a-list item-layout="vertical" size="large" :pagination="pagination" :data-source="dataSource">
          <template #renderItem="{ item }">
          <div class="activityLi" @click="onActivity(item.id)">
            <div class="activityImg">
              <img v-if="item.logo" style="width: 100%;height: 100%;" :src="getImg(item.logo)" />
              <img v-else src="@/assets/img/defaultPhoto.png" alt="">
            </div>
            <div class="activityInfoTime">
              {{momentFormat(item.createdTime,'YYYY-MM-DD')}} <span>{{ item.frequency }}</span>  
            </div>
            <div class="activityInfoTitle">
              {{ item.name }}
            </div>
          </div>
          </template>
          </a-list>
        </div>
      </div>
    </div>
  </div>
  
</template>
<script>
// import { FieldTimeOutlined } from '@ant-design/icons-vue';
import { basicsCourseInfoWeb } from "@/api/finance";
import { listMixin } from "@/mixins";

import { file_service } from "@/api/adminService";


const pagination = {
  pageSize: 10,
  showQuickJumper: true,
};
export default {
  name: 'consultation',
  mixins: [listMixin],
  components: {
    // FieldTimeOutlined,
  },
  mounted() {
    this.title = this.$route.query.type
  },
  data() {
    return {
      pagination,
      noticeData: [],
      policyData: [],
      listUrl: basicsCourseInfoWeb.pageList,
      queryParamFixed: { 
              systemType: 'knowledge'
       },
      current: 1,
      pageSize: 10,
      title: ''
    }
  },
  methods: {
    //课程详情
    onActivity(id) {
      this.$router.push({
        path: "/knowledge/video/Detail",
        query: { id: id ,type:"知识产权培训"}
      })
    },
    getImg(imgUrl) {
      return file_service.imagesWeb(imgUrl)
    },
  }
}
</script>
<style scoped lang="less">
:deep(.ant-list-pagination){
  margin-bottom: 16px;
  clear:both;
  
  float:right
}
.bannerBox {
  position: relative;
  width: 100%;
  //margin-bottom: 20px;

  .bannerImg {
    width: 100%;
    height: 100%;
  }

  .showMoreButton {
    position: absolute;
    top: 55%;
    left: 21.5%;
    width: 170px;
    height: 56px;
    text-align: center;
    line-height: 56px;
    background-color: #0048c4;
    color: #fff;
    cursor: pointer;
  }
}

.breadBox {
  width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.tabBox {
  width: 1200px;
  margin: 0 auto;
  padding: 10px 0 20px 0;

  .listBox {
    overflow: hidden;
    padding: 10px 0;
    cursor: pointer;

    .leftBox {
      float: left;
      width: 24%;
      height: 170px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      float: left;
      margin-left: 2%;
      width: 74%;
      font-size: 14px;

      .title {
        padding: 10px 0;
        font-size: 20px;
        color: #333;
        font-weight: 500;
      }

      .content {
        overflow: hidden;
        margin: 10px 0;
        color: #666;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
      }

      .time {
        padding: 10px 0;
        color: #999;
      }
    }
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab) {
    font-size: 14px;
  }

  :deep(.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active) {
    color: #fff;
    background-color: #1890ff;
  }

  .activityContent {

    .activityLi {
      float: left;
      width: 288px;
      margin: 16px 0;
      margin-right:16px;
      cursor: pointer;
      &:nth-child(4n){
        margin-right: 0;
      }

      .activityImg {
        width: 100%;
        height: 180px;
      }

      .activityInfoTitle {
        padding: 15px 0;
        font-size: 16px;
        color: #333;
      }

      .activityInfoTime {
        overflow: hidden;
        padding: 5px 0;
        font-size: 14px;
        position: relative;
        color: #8b8b8b;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        span{
          position: absolute;
          right:0
        }
      }

      .activityInfoAddress {
        overflow: hidden;
        padding: 5px 10px 20px 10px;
        font-size: 14px;
        color: #666;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
      }
    }

    .activityLi:hover {
      //box-shadow: 5px 5px 10px 10px #f1f1f1;
      //transition: all 0.5s ease 0s;

      -webkit-transition: all 0.3s ease 0s;
      transition: all 0.3s ease 0s;
      //border: 1px solid #ffffff;
      cursor: pointer;
      -webkit-box-shadow: 0 5px 10px 1px #d2e6ff;
      box-shadow: 0 5px 10px 1px #d2e6ff;
      //.activityInfoTitle {
      //	color: #fff;
      //	background-color: #2162e4;
      //
      //}
      //
      //.activityInfoTime {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
      //
      //.activityInfoAddress {
      //	color: #fff;
      //	background-color: #2162e4;
      //}
    }
  }
}
</style>
